import KcApp from "./KcApp";
export * from "./KcApp";
export default KcApp;
